import type { ApiClient } from "../../../infrastructure/http/apiClient";
import type { BookingPolicySnapshot, UpdateBookingPolicyInput } from "../domain/bookingPolicy";

export function loadBookingPolicy(apiClient: ApiClient): Promise<BookingPolicySnapshot> {
  return apiClient.get<BookingPolicySnapshot>("/api/v1/settings/booking-policy");
}

export function updateBookingPolicy(apiClient: ApiClient, input: UpdateBookingPolicyInput): Promise<BookingPolicySnapshot> {
  return apiClient.patch<BookingPolicySnapshot, UpdateBookingPolicyInput>("/api/v1/settings/booking-policy", input);
}
